export default {

  // 접속한 계정에 노출되는 메뉴 리스트
  list:[],

  pageTitle: '',
  pagePath:[],

  // 메인화면에서 노출되는 팝업 리스트
  modalItems: [],
}
